// extracted by mini-css-extract-plugin
module.exports = {"root":"CsiZPk","shortTitle":"zE3_WS"};